import type { Locale } from 'date-fns'
import { cn } from '@cocoonspace/ui/lib/utils'
import { format, isToday } from 'date-fns'

export const WeekHeaderRow = ({
	days,
	formatLocale,
	gridTemplateColumns,
}: {
	days: Date[]
	formatLocale: Locale
	gridTemplateColumns: string
}) => {
	return (
		<div
			className='border-border/70 bg-background/80 sticky top-0 z-30 grid border-b uppercase backdrop-blur-md'
			style={{ gridTemplateColumns }}
		>
			<div className='text-muted-foreground/70 py-2 text-center text-xs' />

			{days.map((day) => {
				const isTodayFlag = isToday(day)

				return (
					<div
						className='text-muted-foreground/70 data-today:text-foreground py-2 text-center text-xs data-today:font-medium'
						data-today={isTodayFlag || undefined}
						key={day.toString()}
					>
						<span className='max-sm:hidden'>
							<span
								className={cn(
									'inline-flex items-center justify-center rounded-full px-2 py-1',
									{
										'bg-primary/10 text-primary px-4 font-medium': isTodayFlag,
									},
								)}
							>
								{format(day, 'EEE dd', { locale: formatLocale })}
							</span>
						</span>

						<span
							aria-hidden='true'
							className='sm:hidden'
						>
							<span
								className={cn(
									'inline-flex items-center justify-center rounded-full px-2 py-1',
									{ 'bg-primary/10 text-primary font-medium': isTodayFlag },
								)}
							>
								{format(day, 'E', { locale: formatLocale })}{' '}
								{format(day, 'd', { locale: formatLocale })}
							</span>
						</span>
					</div>
				)
			})}
		</div>
	)
}
